import { render, staticRenderFns } from "./Statetax.vue?vue&type=template&id=7012e415"
import script from "./Statetax.vue?vue&type=script&lang=js"
export * from "./Statetax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports